import { Controller } from "@hotwired/stimulus"

// Shows a spinner in place of the chevron on tap -- gives instant feedback
// that the tap registered while history.back() loads the previous page,
// which can lag on a slow connection.
export default class extends Controller {
  static targets = ["icon", "spinner"]

  go() {
    this.iconTarget.classList.add("hidden")
    this.spinnerTarget.classList.remove("hidden")
    history.back()
  }
}
